import { inject, Injectable } from '@angular/core';
import { OccConfig } from '@spartacus/core';
import { environment as localEnv } from 'src/environments/environment';
import { environment as devEnv } from 'src/environments/environment.dev';
import { environment as stageEnv } from 'src/environments/environment.staging';
import { environment as stage2Env } from 'src/environments/environment.staging2';
import { environment as prodEnv } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  config = inject(OccConfig);
  getConfig(): EnvironmentModel {
    let env;
    if (this.config?.backend?.occ?.baseUrl?.includes('api-d2-')) {
      env = devEnv;
    } else if (this.config?.backend?.occ?.baseUrl?.includes('api-qa2-')) {
      env = stage2Env;
    } else if (this.config?.backend?.occ?.baseUrl?.includes('api-qa')) {
      env = stageEnv;
    } else if (this.config?.backend?.occ?.baseUrl?.includes('api')) {
      env = prodEnv;
    } else {
      env = localEnv;
    }
    return env;
  }
}

export interface EnvironmentModel {
  production: boolean;
  naStoreUrl: string;
  emeaStoreUrl: string;
  apacStoreUrl: string;
  googleReCaptchaKey: string;
  oneTrustKey: string;
  baseUrl: string;
  webtrekk: {
    trackId: string,
    trackDomain: string
  },
  serverLoggingUrl: string
}
